import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ThemeTexts.css';
import getThemeTexts from '../../data/models/Theme/themeTexts';

/**
 * «Что написано на теме» — надписи, списки дел и привычки из appJSON.
 *
 * Единственный текст на странице темы, который у каждой темы свой: всё
 * остальное — шаблон. Ничего не досочиняем: показываем строки ровно так,
 * как их ввёл автор. Отбор и ограничения — в getThemeTexts.
 */
function ThemeTexts({ appJSON }) {
	const { texts, lists, habits } = getThemeTexts(appJSON);

	if (!texts.length && !lists.length && !habits.length) {
		return null;
	}

	return (
		<div className={s.root}>
			<h2>What&rsquo;s written on it</h2>

			<p className={s.intro}>
				The author&rsquo;s own words on this theme. They come with it
				when you install.
			</p>

			{texts.length > 0 && (
				<ul className={s.texts}>
					{texts.map(text => (
						<li key={text}>{text}</li>
					))}
				</ul>
			)}

			{lists.length > 0 && (
				<div className={s.lists}>
					{lists.map(list => (
						<div className={s.list} key={list.tasks.join('\n')}>
							{list.title && <h3>{list.title}</h3>}
							<ul>
								{list.tasks.map(task => (
									<li key={task}>{task}</li>
								))}
							</ul>
						</div>
					))}
				</div>
			)}

			{habits.length > 0 && (
				<p className={s.habits}>
					Habits it tracks: {habits.join(', ')}
				</p>
			)}
		</div>
	);
}

ThemeTexts.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	appJSON: PropTypes.object.isRequired,
};

export default withStyles(s)(ThemeTexts);
